import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { createReports } from '../../Repositories';

export function useReportsGetQuery(reqParams, options) {
  const reportsReq = useMemo(() => createReports(), []);

  return useQuery(['reportsGetQuery', reqParams], () => reportsReq.getReports(reqParams), {
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    ...options,
  });
}
